import { SupportedLanguage, supportedLanguages } from './language'

export type HomeScreenNumber = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8

const isSupportedLanguage = (language: string): language is SupportedLanguage =>
  supportedLanguages.includes(language as SupportedLanguage)

export const getHomeScreen = (
  language: string,
  screen: HomeScreenNumber
): string => {
  const locale = isSupportedLanguage(language) ? language : 'en'
  return `${process.env.BASE_URL}img/home/screens/localized/${locale}/${screen}.png`
}
